import { Icon } from "@iconify/react";
import React from "react";
import toast from "react-hot-toast";
import {
  Button,
  Card,
  CardBody,
  Col,
  FormGroup,
  Input,
  Row,
  UncontrolledCollapse
} from "reactstrap";

export function checkHasError(field) {
  return field !== undefined && field !== "";
}

const priorityColor = {
  High: "#FF0000", // Red
  Mid: "#FFA500", // Orange
  Low: "#008000" // Green
};

function ReviewReport({ formik, handleNext, handleBack }) {
  return (
    <div className="w-100">
      <div className="my-4">
        <div
          className="accordion d-flex flex-column"
          style={{
            gap: "10px"
          }}
          id="accordionExample"
        >
          {(formik.values.goals || []).map((goal, index) => {
            return (
              <div
                style={{
                  width: "100%",
                  border: "1px solid #ccc",
                  borderRadius: "5px"
                }}
                key={`${(goal?.title || "").replace(",", "").split(" ")[0]}`}
              >
                <div
                  className="card-header"
                  id={`heading${(goal?.title || "").replace(",", "").split(" ")[0]}`}
                  style={{
                    backgroundColor: "#E7F1FD",
                    border: "none",
                    borderRadius: "5px"
                  }}
                >
                  <button
                    className="btn btn-block text-left shadow-none d-flex justify-content-between align-items-center"
                    type="button"
                    data-toggle="collapse"
                    data-target={`#collapse${(goal?.title || "").replace(",", "").split(" ")[0]}`}
                    aria-expanded="true"
                    aria-controls={`collapse${(goal?.title || "").replace(",", "").split(" ")[0]}`}
                  >
                    <span>{goal?.title}</span>

                    <Icon icon="mingcute:down-fill" width="24" height="24" color="#82828C" />
                  </button>
                </div>

                <UncontrolledCollapse
                  defaultOpen={true}
                  toggler={`#heading${(goal?.title || "").replace(",", "").split(" ")[0]}`}
                >
                  <Card style={{ border: "none", borderRadius: "5px" }}>
                    <CardBody>
                      <Row>
                        <Col lg="12">{goal?.description}</Col>
                        <Col
                          lg="12"
                          className="mt-3 d-flex align-items-start"
                          style={{ gap: "10px" }}
                        >
                          <Button
                            className="px-2 py-2 border-0 shadow-none d-flex align-items-center justify-content-between"
                            style={{
                              gap: "2px",
                              color: "#000",
                              backgroundColor: "#F2F2F2"
                            }}
                          >
                            <Icon
                              icon="tabler:point-filled"
                              width="24"
                              height="24"
                              color={priorityColor[goal?.priority]}
                            />
                            <span>{goal?.priority}</span>
                          </Button>
                          <FormGroup className="mb-0">
                            <Input
                              style={{
                                minWidth: "300px"
                              }}
                              type="text"
                              id={`goals[${index}].personName`}
                              name={`goals[${index}].personName`}
                              placeholder="Enter Accountable Person Name"
                              value={goal.personName}
                              onBlur={formik.handleBlur}
                              onChange={(event) => {
                                formik.setFieldValue(
                                  `goals[${index}].personName`,
                                  event.target.value
                                );
                              }}
                            />

                            {Array.isArray(formik.touched?.goals) &&
                            formik.touched.goals[index]?.personName &&
                            Array.isArray(formik.errors?.goals) &&
                            formik.errors.goals[index]?.personName ? (
                              <div className="text-danger">
                                {formik.errors.goals[index]?.personName}
                              </div>
                            ) : null}
                          </FormGroup>
                          <FormGroup className="mb-0">
                            <Input
                              type="select"
                              value={goal.duration}
                              id={`goals[${index}].duration`}
                              name={`goals[${index}].duration`}
                              onChange={(event) => {
                                formik.setFieldValue(
                                  `goals[${index}].duration`,
                                  event.target.value
                                );
                              }}
                              onBlur={formik.handleBlur}
                            >
                              <option value="" disabled>
                                Select Month
                              </option>
                              {[
                                1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19,
                                20, 21, 22, 23, 24
                              ].map((item) => (
                                <option key={item} value={item}>
                                  {item}
                                </option>
                              ))}
                            </Input>
                          </FormGroup>
                        </Col>

                        {(goal?.outcomes || []).map((outcome, idx) => {
                          return (
                            <>
                              <Col lg="12" className="mt-3">
                                <div
                                  className="rounded p-2"
                                  style={{
                                    backgroundColor: "#F3F3F3"
                                  }}
                                >
                                  <div>
                                    <h5>Current Status</h5>
                                    <ul className="pl-4">
                                      <li>{outcome?.current_status}</li>
                                    </ul>
                                  </div>
                                  <hr />
                                  <div>
                                    <h5>Desired Outcome</h5>
                                    <ul className="pl-4">
                                      <li>{outcome?.desired_outcome}</li>
                                    </ul>
                                  </div>
                                </div>
                              </Col>
                              <Col lg="12" className="mt-3">
                                <h3>Action Plan</h3>
                                <div className="d-flex flex-column" style={{ gap: "10px" }}>
                                  {(outcome?.action_plans || [])?.map((actionPlan, actionIdx) => {
                                    return (
                                      <div
                                        key={actionIdx}
                                        className="rounded"
                                        style={{
                                          padding: "0.5rem 1rem",
                                          backgroundColor: "#F3F3F3"
                                        }}
                                      >
                                        {actionPlan?.title}
                                      </div>
                                    );
                                  })}
                                </div>
                              </Col>

                              {idx < goal.outcomes.length - 1 && (
                                <Col lg="12" className="mt-3">
                                  <hr />
                                </Col>
                              )}
                            </>
                          );
                        })}
                      </Row>
                    </CardBody>
                  </Card>
                </UncontrolledCollapse>
              </div>
            );
          })}
        </div>
      </div>

      <div className="d-flex justify-content-end mt-4">
        {/* <button onClick={handleBack} className="btn btn-secondary">
          Back
        </button> */}
        <button
          type="button"
          onClick={async () => {
            formik.setTouched({
              goals: formik.values.goals.map(() => ({
                name: true,
                description: true,
                priority: true,
                duration: true,
                personName: true,
                outComes: (outcomes) =>
                  outcomes.map(() => ({
                    currentStatus: true,
                    desiredStatus: true
                  }))
              }))
            });

            formik.validateForm().then((response) => {
              if (checkHasError(response.goals)) {
                toast("Please fill all the required fields before proceed further.", {
                  icon: "🚫"
                });
                return;
              } else {
                handleNext();
              }
            });
          }}
          className="btn btn-primary"
        >
          Confirm
        </button>
      </div>
    </div>
  );
}

export default ReviewReport;
